<div class="table-container white-bg p-4" [class.table-scroll]="hasOverflowRows">
    <ng-container *ngIf="isProgress">
        <mat-spinner class="spinner" diameter=20></mat-spinner>
    </ng-container>
    <ng-container *ngIf="!isProgress">
        <div class="table-header" [ngClass]="errorhandledashboardwidget.status ? 'hide' : ''">
            <div class="title">
                <h3 class=" primary-text lighter-text">{{title}}</h3>
                <p class="content-s subtitle lighter-text primary-text ">{{subtitle}}</p>
            </div>
            <div class="options-icon">
                <img #moreOptionOrigin *ngIf="mode === 'builder'" src="assets/widgets/more-options.svg" class="tooltip-enable icon-s moreOptions" (click)="openOverlay_moreoptions_click(moreOptionRef,moreOptionOrigin)">
            </div>
        </div>
        <div class="table-body" *ngIf="!handledashboardwidgetnodata.status && !errorhandledashboardwidget.status">
            <!-- <table [ngStyle]="widgetbuildervarservice.tableStyle.table" *ngIf="tableData?.headers?.length">
                <thead [ngStyle]="widgetbuildervarservice.tableStyle.thead">
                    <tr [ngStyle]="widgetbuildervarservice.tableStyle.trhead">
                        <th [ngStyle]="widgetbuildervarservice.tableStyle.th" *ngFor="let header of tableData.headers" [style.width.%]="100 / tableData.headers.length" [ngClass]="{ 'metric-col': header.category === 'metric' }">
                            {{ header.disp }}
                        </th>
                    </tr>
                </thead>
            </table> -->
            <cdk-virtual-scroll-viewport *ngIf="tableData?.headers?.length " class="detail-container" itemSize="40" minBufferPx="200" maxBufferPx="400">
                <!-- [style.width.vw]=" checkmetric(header.value) ? 8 > 100/tableData.headers.length ? '100/tableData.headers.length': '8' : ''" -->
                <table>
                    <thead [ngStyle]="widgetbuildervarservice.tableStyle.thead">
                        <tr [ngStyle]="widgetbuildervarservice.tableStyle.trhead">
                            <th [style.top]="inverseOfTranslation" [ngStyle]="widgetbuildervarservice.tableStyle.th" *ngFor="let header of tableData.headers" [ngClass]="{ 'metric-col': header.category === 'metric' }">
                                {{ header.disp }}
                            </th>
                        </tr>
                    </thead>
                    <tbody [ngStyle]="widgetbuildervarservice.tableStyle.tbody">
                        <tr [ngStyle]="widgetbuildervarservice.tableStyle.trbody" *cdkVirtualFor="let row of displayRows; let i = index" [ngClass]=" _data.style?.table_body['background-color'] == '#f1f6f8' ? 'white-hover':'default-hover'">
                            <td class="tooltip-enable table-data" [tooltip]="checkmetric(header.value) ? _data.style?.compact?.mode === 'auto' ? header?.type === 'size' ? getFormattedSize(row[header.value]) : getFormattedValue(row[header.value]) : _data.style.compact?.type === 'number' ? getFormattedValue(row[header.value])
                            : getFormattedSize(row[header.value]) : row[header.value]" [ngStyle]="widgetbuildervarservice.tableStyle.td" *ngFor="let header of tableData.headers" [ngClass]="[ header.category === 'metric' ? 'metric-col': ''] ">
                                {{checkmetric(header.value) ? _data.style?.compact?.mode === 'auto' ? header?.type === 'size' ? getFormattedSize(row[header.value]) : getFormattedValue(row[header.value]) : _data.style.compact?.type === 'number' ? getFormattedValue(row[header.value])
                                : getFormattedSize(row[header.value]) : row[header.value]}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </cdk-virtual-scroll-viewport>
        </div>
        <ng-container *ngIf="handledashboardwidgetnodata.status || errorhandledashboardwidget.status">
            <div class="dashboardwidget-nodata">
                <div class="nodata-img">
                    <img src="assets/widgets/empty-data.svg" />
                </div>
                <div>
                    <p class="m-0 content-m secondary-text no-result">{{handledashboardwidgetnodata.status ? handledashboardwidgetnodata.errmsg:errorhandledashboardwidget.errmsg}}
                    </p>
                </div>
            </div>
        </ng-container>
    </ng-container>

</div>

<ng-container (click)="$event.stopPropagation()">

    <ng-template #moreOptionRef>
        <!-- *ngIf="moreOptionState" (click)="$event.stopPropagation()" -->
        <div class="more-option radius-s" #filterOrigin>
            <div class="more-option-container radius-s primary-bg py-2 tooltip-shadow px-3">
                <div class="icon-div " (click)="refreshWidget()">
                    <img src="assets/widgets/refresh.svg" class="enable-action" tooltip="Refresh" class="tooltip-enable" style="cursor:pointer;">
                </div>
                <div class="vertical-line border-light-left"></div>
                <div class="icon-div " (click)="download_click()">

                    <img src="assets/widgets/download.svg" [ngClass]="handledashboardwidgetnodata.status ? 'disable-action':'enable-action'" [tooltip]="'Download'" class="tooltip-enable">

                    <div class="vertical-line border-light-left"></div>
                </div>
                <div class="vertical-line border-light-left"></div>
                <div class="icon-div " (click)="openOverlay_templateRef(dateFilterRef,filterOrigin,'datefilter')">
                    <img src="assets/widgets/filter.svg" [tooltip]="'Filter'" class="enable-action tooltip-enable">
                    <!-- <img  style="cursor:default;opacity: 32%" src="assets/widgets/filter.svg" [tooltip]="moreoptiontitles[3]" 
                  class="disable-action tooltip-enable">  -->
                    <div class="vertical-line border-light-left"></div>
                </div>
                <div class="vertical-line border-light-left"></div>
                <div class="icon-div" (click)="fullscreen_click(headerContent,subheaderContent,bodyContent)" [tooltip]="'Maximize'" class="enable-action tooltip-enable">
                    <!-- #fullscreenOrigin -->
                    <img src="assets/widgets/full-screen.svg">


                    <!-- [ngClass]="handledashboardwidgetnodata.status ? 'disable-action':'enable-action'"
                  [tooltip]="'Fill screen'" class="tooltip-enable">  nodatavariable -->


                    <!-- ,fullscreenOrigin -->
                    <!-- <ng-container *ngIf="widgetType=='Chart'"> -->
                    <!-- <div class="vertical-line border-light-left"></div> -->
                </div>
                <div class="vertical-line border-light-left"></div>
                <div class="icon-div ">
                    <img *ngIf="widgetInfo.type =='table' || widgetInfo.type =='label'" style="cursor:default;opacity: 32%;" src="assets/widgets/edit-color-disable.svg" class="tooltip-enable">
                </div>

            </div>
            <div class="arrow-div m-0">
                <!-- <div class="arrow">

          </div> -->
                <img src="assets/widgets/play-gray.svg">
            </div>
            <div class="close-option">
                <button class="icon-button p-3 tooltip-enable primary-bg radius-s tooltip-shadow" (click)="closeOptions_click()">x
              <!-- <img class="exit-option" src="assets/widgets/close-more-options.svg" class="enable-action"
          (click)="closeOptions_click()"> -->
              <!-- <img class="exit-option" src="assets/widgets/window-close-line.svg"
                  class="enable-action" (click)="closeOptions_click()"> -->
          </button>
            </div>
        </div>
    </ng-template>

    <ng-template #dateFilterRef>
        <div class="more-option-filter-container border-light  primary-bg radius-m lighter-text dropdown-shadow ">
            <div class="more-option-filter">

                <div class="filter-header-wrapper radius-m primary-bg pt-6 px-6">
                    <ul id="dateFilter" class="span-m primary-text m-0 p-0">
                        <ng-container *ngFor="let filter of dashboardBuilderVarService.relativeTimeMetadata; let i = index">
                            <li class="li-m" (click)="relativeTimeClick('dateFilter',filter.value,'relativetime')">
                                {{ filter.disp }} </li>
                        </ng-container>
                    </ul>
                    <!-- <hr class="horizondal-seperator border-light-bottom"> -->
                </div>
                <div class="seperator border-light-bottom radius-m mx-6"></div>
                <div class="filter-body-wrapper pb-6 px-6 radius-m">
                    <form [formGroup]="selectTime">
                        <div class="filter-body-row-1">
                            <p class="primary-text content-l">From</p>
                            <!-- <input type="date" id="start" [value]="fromDate | date : 'yyyy-MM-dd'"
                          (input)="fromDate = $event.target.value"
                          (change)="load_widgetData('dateFilter')"> -->

                            <!-- <input class="primary-bg input-m primary-text input-border tooltip-enable border-none" type="date" id="to" formControlName="fromDate" [min]="mindate"
                          [max]="maxdate"
                          tooltip="{{selectTime.controls.toDate.value | date:'dd MMM yy HH:mm'}}" style="cursor:pointer;"> -->
                            <input class="primary-bg input-m primary-text tooltip-enable border-none" type="date" id="to" formControlName="fromDate" [min]="mindate" [max]="maxdate" tooltip="{{selectTime.controls.toDate.value | date:'dd MMM yy'}}" style="cursor:pointer;">

                        </div>
                        <div class="filter-body-row-2 ">
                            <p class="primary-text content-l">To</p>
                            <!-- <input type="date" id="end" [value]="toDate | date : 'yyyy-MM-dd'"
                          (input)="toDate = $event.target.value"
                          (change)="load_widgetData('dateFilter')"> -->
                            <input class="primary-bg input-m primary-text tooltip-enable border-none" type="date" id="from" formControlName="toDate" [min]="mindate" [max]="maxdate" tooltip="{{selectTime.controls.toDate.value | date:'dd MMM yy'}}" style="cursor:pointer;">

                        </div>
                        <button class="apply submit" (click)="dateFilterClick()">Apply</button>
                        <span class="date-validation alert-text span-s" *ngIf="selectTime.errors">
                      {{sharedService.metaData.rule.lookbackmeta.formerrormsg.invalidtime}} </span>
                    </form>


                </div>
            </div>
        </div>
    </ng-template>
</ng-container>


<ng-template #headerContent>{{title}}</ng-template>
<ng-template #subheaderContent>{{subtitle}}</ng-template>
<ng-template #bodyContent>
    <div class="chart-body">
        <table [ngStyle]="widgetbuildervarservice.tableStyle.table">
            <thead [ngStyle]="widgetbuildervarservice.tableStyle.thead">
                <tr [ngStyle]="widgetbuildervarservice.tableStyle.trhead">
                    <th [ngStyle]="widgetbuildervarservice.tableStyle.th" *ngFor="let header of tableData.headers" [ngClass]="{ 'metric-col': header.category === 'metric' }">
                        {{ header.disp }}
                    </th>
                </tr>
            </thead>
            <tbody [ngStyle]="widgetbuildervarservice.tableStyle.tbody">
                <tr [ngStyle]="widgetbuildervarservice.tableStyle.trbody" *ngFor="let row of displayRows; let i = index" [ngClass]="{ 'row-even': i % 2 === 0 }">
                    <td [ngStyle]="widgetbuildervarservice.tableStyle.td" *ngFor="let header of tableData.headers" [ngClass]="{ 'metric-col': header.category === 'metric' }">
                        {{ _data.style.compact?.type === 'number' ? getFormattedValue(row[header.value]) : getFormattedSize(row[header.value]) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>